import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="banner"
export default class extends Controller {
    static outlets = ["drawer"]

    toggleDrawer() {
        this.drawerOutlet.toggle()
    }

    handleDrawerOpen() {
        this.interactiveElements.forEach(element => {
            if (element.classList.contains("swap")) {
                element.classList.toggle("swap-active", true)
                return
            }

            this.#disable(element)
        })
    }

    handleDrawerClose() {
        this.interactiveElements.forEach(element => {
            if (element.classList.contains("swap")) {
                element.classList.toggle("swap-active", false)
                return
            }

            this.#enable(element)
        })
    }

    get interactiveElements() {
        return this.element.querySelectorAll("a, button, input")
    }

    /** @param {HTMLElement} element */
    #disable(element) {
        element.toggleAttribute("disabled", true)
        element.setAttribute("tabindex", -1)
    }

    /** @param {HTMLElement} element */
    #enable(element) {
        element.toggleAttribute("disabled", false)
        element.removeAttribute("tabindex")
    }
}
